import { Component, OnInit, ElementRef, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'filter-columns',
  templateUrl: './filter-columns.component.html',
  styleUrls: ['./filter-columns.component.scss'],
  host: { '(document:click)': 'onClick($event)' }
})
export class FilterColumnsComponent implements OnInit {

  // Inputs variables
  @Input() items: any;

  // Output variables
  @Output() onItemSelect: EventEmitter<any> = new EventEmitter<any>();

  // Public Variables
  public dropdownOpened: boolean = false;
  public itemsList: any;

  constructor(private _eref: ElementRef) { }

  ngOnInit() {
    this.itemsList = this.items;
  }

  // On Click Filter Icon
  public onClickFilter(): void {
    this.dropdownOpened = !this.dropdownOpened;
  }

  // On element click
  public onClick(event): void {
    if (!this._eref.nativeElement.contains(event.target) && this.dropdownOpened) this.dropdownOpened = false;
  }

  // On Click Item List
  public onClickItem(activity: any, group: any) {
    this.itemsList.list.filter(filter => {
      filter.items.filter(item => item.key === activity.key)
        .map(result => {
          result.value = !result.value;
          this.onItemSelect.emit(Object.assign(activity, { group: group }));
        });
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/filter-columns/filter-columns.component.ts